export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "%0 z %1": "%0 of %1",
        "%0 znaków": "%0 characters",
        "<Brak nazwy>": "<No name>",
        "${el.text}": "${el.text}",
        "${getCurrentScope().label}": "${getCurrentScope().label}",
        "${item.entityName}": "${item.entityName}",
        "${item.text}": "${item.text}",
        "${props.inputPlaceholder}": "${props.inputPlaceholder}",
        "1 godzina": "1 hour",
        "10 minut": "10 minutes",
        "12 godzin": "12 hours",
        "15 minut": "15 minutes",
        "24 godziny": "24 hours",
        "3 godziny": "3 hours",
        "30 minut": "30 minutes",
        "5 minut": "5 minutes",
        "6 godzin": "6 hours",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "To test the validity of keys, first save the form.",
        "Adaptive sampling": "Adaptive sampling",
        "Administracja": "Administration",
        "Administracja - Kraje": "Administration - Countries",
        "Administracja - Miasta": "Administration - Cities",
        "Administracja - Role": "Administration - Roles",
        "Administracja - Stanowiska pracy": "Administration - Job positions",
        "Administracja - Użytkownicy": "Administration - Users",
        "Administracja - Województwa": "Administration - Provinces",
        "Administracja - Zespoły": "Administration - Teams",
        "Administratorzy": "Administrators",
        "Adres domenowy": "Domain address",
        "Adres e-mail potwierdzony": "Email address confirmed",
        "Adres email": "Email address",
        "Adres email nadawcy": "Sender's email address",
        "Adres IP": "IP address",
        "Adres IP: %0": "IP address: %0",
        "Adresy należy oddzielać przecinkami i muszą zaczynać się od http(s).": "Addresses should be separated by commas and must start with http(s).",
        "Akcja": "Action",
        "Akcje": "Actions",
        "Aktualizacja danych exif": "EXIF data update",
        "Aktualizuj": "Update",
        "Aktualna sesja": "Current session",
        "Aktualne hasło": "Current password",
        "Aktualne urządzenie": "Current device",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywne sesje": "Active sessions",
        "Aktywni": "Active",
        "Aktywny": "Active",
        "Angielski": "English",
        "Anonimizuj": "Anonymize",
        "Anuluj": "Cancel",
        "Aplikacja monitorująca": "Monitoring application",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "Application will restart within a maximum of 60 seconds.",
        "Aranżacja": "Arrangement",
        "Autor": "Author",
        "Autoryzacja wymagana": "Authorization required",
        "Azure AD": "Azure AD",
        "Azure Application Insights": "Azure Application Insights",
        "Basic Auth": "Basic Auth",
        "Baza danych": "Database",
        "Bezpieczeństwo": "Security",
        "Bezpieczne połączenie SSL": "Secure SSL connection",
        "Blokada konta": "Account lock",
        "Blokada konta do": "Account lock until",
        "Blokowanie kont": "Account locking",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "Error 404. Requested resource not found.",
        "Błędne": "Invalid",
        "Błędy": "Errors",
        "Bool": "Bool",
        "brak": "none",
        "Brak danych": "No data",
        "Brak elementów": "No items",
        "Brak kluczy": "No keys",
        "Brak opcji": "No options",
        "Brak podanych adresów oznacza, że nie będą monitorowane żadne żądania HTTP.": "No addresses provided means no HTTP requests will be monitored.",
        "Brak wersji": "No version",
        "Brak wyboru": "No selection",
        "Brak wyników": "No results",
        "Brak zdefiniowanych ról.": "No roles defined.",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "Co 10 dni": "Every 10 days",
        "Co 10 minut": "Every 10 minutes",
        "Co 12 godzin": "Every 12 hours",
        "Co 15 minut": "Every 15 minutes",
        "Co 2 godziny": "Every 2 hours",
        "Co 2 minuty": "Every 2 minutes",
        "Co 2 tygodnie": "Every 2 weeks",
        "Co 20 minut": "Every 20 minutes",
        "Co 3 godziny": "Every 3 hours",
        "co 3 miesiące": "every 3 months",
        "Co 3 miesiące": "Every 3 months",
        "co 30 dni": "every 30 days",
        "Co 30 minut": "Every 30 minutes",
        "Co 4 miesiące": "Every 4 months",
        "Co 5 dni": "Every 5 days",
        "Co 5 minut": "Every 5 minutes",
        "Co 6 godzin": "Every 6 hours",
        "co 6 miesięcy": "every 6 months",
        "Co drugi dzień": "Every other day",
        "Co drugi miesiąc": "Every other month",
        "Co godzinę": "Every hour",
        "Co miesiąc": "Every month",
        "Co minutę": "Every minute",
        "Co pół roku": "Every half year",
        "co rok": "every year",
        "Co tydzień": "Every week",
        "Codziennie": "Daily",
        "Connection String": "Connection String",
        "Cron": "Cron",
        "Czas": "Time",
        "Czas nieaktywności użytkownika po którym zostanie wylogowany z panelu administracyjnego [min": "User inactivity time after which they will be logged out of the admin panel [min",
        "Czas trwania blokady": "Lock duration",
        "Czas uruchomienia": "Run time",
        "Czy aby na pewno chesz zrestartować aplikacje?": "Are you sure you want to restart the application?",
        "Czy na pewno chcesz usunąć widget?": "Are you sure you want to delete the widget?",
        "Dalej": "Next",
        "Dane exif": "EXIF data",
        "Dashboard aktywny": "Active dashboard",
        "Dashboard domyślny": "Default dashboard",
        "Dashboard został dodany.": "Dashboard has been added.",
        "Dashboard został skopiowany.": "Dashboard has been copied.",
        "Dashboard został usunięty.": "Dashboard has been deleted.",
        "Dashboard został zaktualizowane.": "Dashboard has been updated.",
        "Dashboardy": "Dashboards",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data modyfikacji": "Modification date",
        "Data od": "Date from",
        "Data rejestracji": "Registration date",
        "Data uruchomienia": "Run date",
        "Data uruchomienia (UTC)": "Run date (UTC)",
        "Data usunięcia": "Deletion date",
        "Data utworzenia": "Creation date",
        "Data utworzenia wersji": "Version creation date",
        "Data wygaśnięcia": "Expiration date",
        "Data wylogowania": "Logout date",
        "Data zalogowania": "Login date",
        "Data zdarzenia": "Event date",
        "DateTime": "DateTime",
        "Długość historii haseł": "Password history length",
        "Dni": "Days",
        "Do akceptacji": "For approval",
        "do czasu ręcznego odblokowania": "until manually unlocked",
        "Dodaj": "Add",
        "Dodaj dashboard": "Add dashboard",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "Add one or more widgets to gain insight into your team's progress.",
        "Dodaj nowy folder": "Add new folder",
        "Dodaj pliki": "Add files",
        "Dodaj rolę": "Add role",
        "Dodaj shortcode": "Add shortcode",
        "Dodaj użytkownika": "Add user",
        "Dodaj widget": "Add widget",
        "dodał": "added",
        "Dodanie": "Adding",
        "Dodanie dashboardu": "Adding dashboard",
        "Dodanie roli": "Adding role",
        "Dodanie użytkownika": "Adding user",
        "dodany": "added",
        "Dodanych plików %0 (limit wynosi %1).": "Files added %0 (limit is %1).",
        "Dokument PDF": "PDF document",
        "Dokument tekstowy": "Text document",
        "Dołącz stack trace": "Attach stack trace",
        "Domyślna": "Default",
        "Domyślne": "Default",
        "Domyślne filtry": "Default filters",
        "Domyślny": "Default",
        "Domyślny poziom logowania": "Default logging level",
        "Dostęp niezdefiniowany": "Access undefined",
        "Dostęp przyznany": "Access granted",
        "Dostęp zabroniony": "Access denied",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "A new update is available. Please save your work progress and click the \"Update\" button. You can also accept the update by refreshing the browser window. Not updating may cause errors.",
        "Double": "Double",
        "Dozwolone rozszerzenia: %0.": "Allowed extensions: %0.",
        "Dozwolone typy plików: %0.": "Allowed file types: %0.",
        "Dsn": "Dsn",
        "Duży układ siatki": "Large grid layout",
        "Działania masowe": "Bulk actions",
        "E-mail": "E-mail",
        "Edycja aranżacji dashboardu": "Dashboard arrangement edit",
        "Edycja dashboardu": "Dashboard edit",
        "Edycja logów": "Logs edit",
        "Edycja roli": "Role edit",
        "Edycja użytkownika": "User edit",
        "Edytowana wersja": "Edited version",
        "Edytuj": "Edit",
        "Edytuj filtr": "Edit filter",
        "Edytuj uprawnienia": "Edit privileges",
        "Eksport": "Export",
        "Element został przywrócony.": "Item has been restored.",
        "Element został usunięty.": "Item has been deleted.",
        "Elementy zostały usunięte.": "Items have been deleted.",
        "Email potwierdzony": "Email confirmed",
        "False": "False",
        "Filtr domyślny": "Default filter",
        "Filtr prywatny": "Private filter",
        "Filtr został usunięty": "Filter has been deleted",
        "Filtr został zapisany": "Filter has been saved",
        "Filtry": "Filters",
        "Folder główny": "Main folder",
        "Folder plików": "File folder",
        "Foldery": "Folders",
        "Godziny": "Hours",
        "Grafana Cloud": "Grafana Cloud",
        "Grupa": "Group",
        "Harmonogram zadań": "Task schedule",
        "Harmonogram został zmieniony": "Schedule has been changed",
        "Hasło": "Password",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "Password must contain at least one special character e.g.: ~ @ # $ % ^ & *",
        "Hasło zostało zmienione. Zaloguj się ponownie": "Password has been changed. Log in again",
        "Historia logowania": "Login history",
        "Historia zadania": "Task history",
        "Host": "Host",
        "i": "and",
        "Id": "Id",
        "ID": "ID",
        "ID lub typ zadania": "ID or task type",
        "Id modelu: %0": "Model ID: %0",
        "Id obiektu": "Object ID",
        "Id sesji": "Session ID",
        "ID zadania": "Task ID",
        "Id zdarzenia": "Event ID",
        "Identyfikator zadania": "Task identifier",
        "Imię": "First name",
        "Imię i Nazwisko": "First and Last Name",
        "Import": "Import",
        "Import użytkowników": "User import",
        "Inspekcja": "Inspection",
        "Instalacja": "Installation",
        "Int": "Int",
        "Kalendarz - Kategorie zasobów": "Calendar - Resource categories",
        "Katalog został utworzony": "Catalog has been created",
        "Klucz prywatny": "Private key",
        "Klucz publiczny": "Public key",
        "Klucze są nie prawidłowe.": "Keys are invalid.",
        "Klucze są prawidłowe.": "Keys are valid.",
        "Kod C#": "C# code",
        "Kod CSS": "CSS code",
        "Kod HTML": "HTML code",
        "Kod JavaScript": "JavaScript code",
        "Kod TypeScript": "TypeScript code",
        "Kod Vue (Single-File Component)": "Vue code (Single-File Component)",
        "Kod wertfikacyjny": "Verification code",
        "Kod weryfikacyjny jest nieprawidłowy.": "Verification code is invalid.",
        "Kolejka": "Queue",
        "Kolor tła": "Background color",
        "Komponent React": "React component",
        "Komunikat": "Message",
        "Konfiguracja harmonogramu (czas UTC)": "Schedule configuration (UTC time)",
        "Konfiguracja została zmieniona.": "Configuration has been changed.",
        "Konsola aplikacji": "Application console",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "Application console never logs from the following namespaces:",
        "Konta użytkowników zostały odblokowane": "User accounts have been unlocked",
        "Konta użytkowników zostały usunięte z systemu": "User accounts have been removed from the system",
        "Konta użytkowników zostały zablokowane": "User accounts have been locked",
        "Kontakt": "Contact",
        "Kontakty - Typ działania": "Contacts - Action type",
        "Konto aktywne": "Active account",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "Account will remain inactive until the email address is confirmed",
        "Konto z dostępem do panelu": "Account with access to panel",
        "Konto zanonimizowane": "Account anonymized",
        "Konwertuj obrazy do formatu WebP": "Convert images to WebP format",
        "Kopiuj": "Copy",
        "Kopiuj pole": "Copy field",
        "Kosz": "Bin",
        "Lewy panel": "Left panel",
        "Licencja": "License",
        "linie": "lines",
        "Lista dozwolonych / wykluczonych żądań HTTP": "List of allowed/excluded HTTP requests",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "List of effective user privileges resulting from individual privileges and roles.",
        "Lista jest pusta": "List is empty",
        "Lista zaufanych adresów IP": "Trusted IP address list",
        "Logi wydajnościowe": "Performance logs",
        "Logowanie": "Login",
        "Logowanie zakończyło się niepowodzeniem.": "Login failed.",
        "Logowanie zależności / żądań typu HTTP": "Dependency / HTTP request logging",
        "Logowanie zdarzeń": "Event logging",
        "Loguj wybrane": "Log selected",
        "Long": "Long",
        "Ładowanie elementów...": "Loading items...",
        "Maksymalna rozdzielość obrazu po optymalizacji: %0x%1px": "Maximum image resolution after optimization: %0x%1px",
        "Maksymalny rozmiar pliku: %0MB.": "Maximum file size: %0MB.",
        "Mały układ siatki": "Small grid layout",
        "Metoda autentykacji": "Authentication method",
        "Microsoft Aspire": "Microsoft Aspire",
        "Miesiące": "Months",
        "Minimalna długość hasła": "Minimum password length",
        "Minuty": "Minutes",
        "Modyfikacja": "Modification",
        "Moje filtry": "My filters",
        "Moje pliki": "My files",
        "Monitor kolejek": "Queue monitor",
        "Monitoring": "Monitoring",
        "Monitoring aplikacji": "Application monitoring",
        "Monitorowane adresy URL dla żądań HTTP": "Monitored URL addresses for HTTP requests",
        "Monitoruj bazy danych (SQL, Redis, ElasticSearch)": "Monitor databases (SQL, Redis, ElasticSearch)",
        "Monitoruj statystyki .NET": ".NET statistics monitoring",
        "Monitoruj żądania HTTP": "HTTP request monitoring",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Modification of this account is limited. Inactive fields are synchronized with external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "Modification of this account is limited. Inactive fields are synchronized with external database %0.",
        "Możliwość zmiany hasła jest zablokowana. Obsługa hasła znajduje się po stronie zewnętrznej bazy danych %0.": "Password change option are blocked. Password handling is on external database %0 side.",
        "Mój tytuł": "My title",
        "Na pewno usunąć": "Are you sure you want to delete",
        "Nagłówki HTTP": "HTTP headers",
        "Najpierwsz zapisz wprowadzone zmiany": "First save introduced changes",
        "Name": "Name",
        "Następna strona": "Next page",
        "Nazwa": "Name",
        "Nazwa dashboardu": "Dashboard name",
        "Nazwa filtra": "Filter name",
        "Nazwa katalogu": "Directory name",
        "Nazwa nadawcy": "Sender name",
        "Nazwa pliku": "File name",
        "Nazwa pliku została zmieniona.": "File name has been changed.",
        "Nazwa pola": "Field name",
        "Nazwa roli": "Role name",
        "Nazwa typu": "Type name",
        "Nazwa urządzenia": "Device name",
        "Nazwa usługi": "Service name",
        "Nazwa użytkownika": "Username",
        "Nazwa zadania": "Task name",
        "Nazwisko": "Last name",
        "Nie": "No",
        "Nie loguj wybranych": "Do not log selected",
        "Nie masz uprawnień do panelu administracyjnego.": "You do not have privileges to the admin panel.",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "You do not have privileges to this view. View state may have changed, refresh and check or try again later.",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "You cannot modify the profile of the substituted user.",
        "Nie możesz modyfikować uprawnień": "You cannot modify privileges",
        "Nie można dodać pliku \"%0\" z powodu: %1.": "Cannot add file \"%0\" due to: %1.",
        "Nie można usunąć swojego konta.": "Cannot delete your own account.",
        "Nie udało się pobrać konfiguracji dashboardu": "Failed to fetch dashboard configuration",
        "Nie udało się pobrać listy filtrów": "Failed to fetch filter list",
        "Nie udało się pobrać listy kolejek": "Failed to fetch queue list",
        "Nie udało się pobrać listy ról": "Failed to fetch role list",
        "Nie udało się pobrać listy typów modeli": "Failed to fetch model type list",
        "Nie udało się pobrać widgetu/ów": "Failed to fetch widget(s)",
        "Nie udało się usunąć szablonu": "Failed to delete template",
        "Nie udało się wysłać pliku": "Failed to send file",
        "Nie udało się załadować elementów": "Failed to load items",
        "Nie udało się zapisać filtra": "Failed to save filter",
        "Nie udało się zapisać ustawień dashboardu": "Failed to save dashboard settings",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Not all selected items were moved. You do not have the required privileges or, in the case of moving directories, the target directory is a subdirectory of the source directory. Directories and files that could not be moved remain in the Selected tab.",
        "Nie wybrano żadnego użytkownika.": "No user selected.",
        "nie wymuszaj zmiany hasła": "do not enforce password change",
        "Nie zdefiniowano żadnych ról.": "No roles defined.",
        "Nie znaleziono filtrów.": "No filters found.",
        "Nie znaleziono kolumn.": "No columns found.",
        "Nie znaleziono pasujących elementów.": "No matching items found.",
        "Nie znaleziono właściwego widgetu": "Proper widget was not found",
        "Nie znaleziono żadnego pola.": "No field found.",
        "Nie znaleziono żadnych elementów": "No items found",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Nieaktywni": "Inactive",
        "niedozwolone rozszerzenie pliku (%0)": "disallowed file extension (%0)",
        "niedozwolony typ pliku (%0)": "disallowed file type (%0)",
        "Niepotwierdzeni": "Unconfirmed",
        "Nieprawidłowy adres email": "Invalid email address",
        "Nieprawidłowy adres URL": "Invalid URL",
        "Nieprzeczytane": "Unread",
        "Nieudane logowania": "Failed logins",
        "Nieznany typ pliku": "Unknown file type",
        "Nikomu nie przydzielono uprawnień": "No privileges assigned to anyone",
        "Nowe hasło": "New password",
        "Numer sesji": "Session number",
        "Numer telefonu": "Phone number",
        "OAuth2 dla Exchange Online": "OAuth2 for Exchange Online",
        "Obiekt %0 został %1": "Object %0 has been %1",
        "Obiekt JSON": "JSON object",
        "Obraz został wycięty.": "Image has been cropped.",
        "Oczekujące": "Pending",
        "Oczekuje na wysłanie": "Pending to send",
        "Odblokuj": "Unlock",
        "Odrzucone": "Rejected",
        "Odśwież": "Refresh",
        "Odznacz": "Uncheck",
        "Ok": "Ok",
        "OpenTelemetry": "OpenTelemetry",
        "Opis": "Description",
        "Opisy": "Descriptions",
        "Opróżnij kategorię": "Empty category",
        "Optymalizuj rozdzielczość obrazów": "Optimize image resolution",
        "Oraz hasło": "And password",
        "Oraz nowe hasło": "And new password",
        "Ostatnia aktywność": "Last activity",
        "Ostatnia strona": "Last page",
        "Ostrzeżenia": "Warnings",
        "Otwórz": "Open",
        "Pierwsza strona": "First page",
        "Plik audio": "Audio file",
        "Plik binarny": "Binary file",
        "Plik CSS": "CSS file",
        "Plik CSV": "CSV file",
        "Plik DOC": "DOC file",
        "Plik DOCX": "DOCX file",
        "Plik GIF": "GIF file",
        "Plik HTML": "HTML file",
        "Plik jest wysyłany": "File is being sent",
        "Plik JPEG": "JPEG file",
        "Plik JPG": "JPG file",
        "Plik MP4": "MP4 file",
        "Plik PNG": "PNG file",
        "Plik skompresowany": "Compressed file",
        "Plik z logami": "Log file",
        "Plik ZIP": "ZIP file",
        "Plik został wysłany": "File has been sent",
        "Pliki": "Files",
        "Pliki do wysłania: %0": "Files to send: %0",
        "Pliki współdzielone": "Shared files",
        "po %0 nieudanych próbach logowania": "after %0 failed login attempts",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "After selecting this option, user accounts will be removed from the system. Do you want to continue?",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "After selecting this option, individual privileges and those derived from roles are ignored.",
        "Pobierz": "Download",
        "Poczta wychodząca": "Outgoing mail",
        "Podaj kod weryfikacyjny": "Enter verification code",
        "Podaj swój adres email": "Enter your email address",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "Creating a main administrator account is required during the first launch.",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "There was a problem saving recaptcha during login attempt. Try again",
        "Podczas przesyłania plików wystąpił nieznany błąd": "Unknown error occurred during file upload",
        "Podgląd": "Preview",
        "Podziedziałek - Piątek": "Monday - Friday",
        "Pokaż historię": "Show history",
        "Pokaż szczegóły": "Show details",
        "Pokaż więcej": "Show more",
        "pokaż więcej...": "show more...",
        "Pole \"Email\" jest wymagane.": "Field \"Email\" is required.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "Field \"Username\" is required.",
        "Pole \"Nazwa\" jest wymagane.": "Field \"Name\" is required.",
        "Pole \"Szerokość\" jest wymagane.": "Field \"Width\" is required.",
        "Pole \"Wysokość\" jest wymagane.": "Field \"Height\" is required.",
        "Pole jest wymagane": "Field is required",
        "Pole nie może zawierać spacji": "Field cannot contain spaces",
        "Pole skopiowane": "Field copied",
        "Polityka prywatności": "Privacy policy",
        "Polski": "Polish",
        "Poprzednia strona": "Previous page",
        "Porównaj %0": "Compare %0",
        "Porównaj z edytowaną wersją": "Compare with edited version",
        "Porównywana wersja": "Compared version",
        "Port": "Port",
        "Potwierdzenia": "Confirmations",
        "Potwierdzenie kopiowania": "Copy confirmation",
        "Potwierdzenie przywrócenia": "Restore confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdzenie wylogowania użytkownika": "User logout confirmation",
        "Potwierdzenie zmiany statusu": "Status change confirmation",
        "Potwierdź": "Confirm",
        "Powiadomienia": "Notifications",
        "Powrót": "Back",
        "Powtórz hasło": "Repeat password",
        "Powtórzone": "Repeated",
        "Pozostałe": "Others",
        "Pozostało %0 znaków.": "Remaining %0 characters.",
        "Prawy panel": "Right panel",
        "Profil użytkownika": "User profile",
        "Profil został zaktualizowany.": "Profile has been updated.",
        "Próbkowanie": "Sampling",
        "Prywatny": "Private",
        "Przeczytane": "Read",
        "Przefiltrowani użytkownicy": "Filtered users",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "The browser you are using does not support PUSH notifications",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "exceeded allowed file size (%0 MB)",
        "Przeniesienie wybranych elementów": "Move selected items",
        "przeniesiony do kosza": "moved to bin",
        "Przenieś": "Move",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "Move${selected.length > 1 ? ' selected' : ''}",
        "przeniósł do kosza": "moved to bin",
        "Przestrzeń nazw": "Namespace",
        "Przesyłanie plików powiodło się.": "File upload succeeded.",
        "Przetestuj poprawność zapisanych kluczy": "Test saved keys validity",
        "Przetestuj ustawienia poczty": "Test mail settings",
        "Przetwarzane": "Processing",
        "Przypisanie ról": "Assign roles",
        "Przywrócenie": "Restore",
        "przywrócił z kosza": "restored from bin",
        "przywrócony z kosza": "restored from bin",
        "Przywróć": "Restore",
        "Przywróć filtr": "Restore filter",
        "Przyznaj dostęp": "Grant access",
        "Publiczny": "Public",
        "Ranga": "Rank",
        "ReCaptcha": "ReCaptcha",
        "Rejestr zmian": "Change log",
        "Repozytorium plików": "File repository",
        "Resetuj": "Reset",
        "Rola": "Role",
        "Rola aktywna": "Active role",
        "Rola domyślna": "Default role",
        "Rola została dodana.": "Role has been added.",
        "Rola została usunięta.": "Role has been deleted.",
        "Rola została zaktualizowana.": "Role has been updated.",
        "Role i uprawnienia": "Roles and privileges",
        "Role użytkownika": "User roles",
        "Role zostały przypisane": "Roles have been assigned",
        "Rozmiar": "Size",
        "Rozmiar pliku": "File size",
        "Rozmiar zdjęcia został zmieniony.": "Photo size has been changed.",
        "Sentry": "Sentry",
        "Sesja": "Session",
        "Sesja nr %0": "Session no. %0",
        "Sesja użytkownika": "User session",
        "Skrypt SQL": "SQL script",
        "słowa": "words",
        "Start": "Start",
        "Status": "Status",
        "String": "String",
        "Strona główna": "Home page",
        "Synchronizacja użytkowników": "User synchronization",
        "System": "System",
        "Szczegóły": "Details",
        "Szczegóły zadania": "Task details",
        "Szczegóły zdarzenia": "Event details",
        "Szczegóły zdarzenia nr %0": "Event details no. %0",
        "Szerokość": "Width",
        "Szkic": "Draft",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "This option is used to enable or disable inheritance in a given field",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "This page is protected by reCAPTCHA and Google.",
        "Tagi": "Tags",
        "Tak": "Yes",
        "Tekst alternatywny": "Alternative text",
        "Ten dashboard nie zawiera żadnych widgetów": "This dashboard does not contain any widgets",
        "Ten element nie zawiera menu kontekstowego.": "This item does not contain a context menu.",
        "Tenant ID": "Tenant ID",
        "Teraz": "Now",
        "Testowy adres email": "Test email address",
        "To pole jest wymagane": "This field is required",
        "Tracing": "Tracing",
        "True": "True",
        "Twoje hasło wygasło. Zmień je na nowe.": "Your password has expired. Change it to a new one.",
        "Tydzień": "Week",
        "Tylko moje": "Only mine",
        "Typ": "Type",
        "Typ konta": "Account type",
        "Typ mime": "Mime type",
        "Typ obiektu": "Object type",
        "Typ pliku": "File type",
        "Typ właściwy": "Proper type",
        "typu \"%0\" o ID \"%1\"": "type \"%0\" with ID \"%1\"",
        "Układ listy": "List layout",
        "Uprawnienia": "Privileges",
        "Uri": "URI",
        "Uruchom zadanie": "Run task",
        "Urządzenie zostało usunięte.": "Device has been deleted.",
        "Ustaw domyślny poziom logowania. Logi poniżej tego poziomu nie bądą zbierane niezależnie od pozostałych ustawień.": "Set default logging level. Logs below this level will not be collected regardless of other settings.",
        "Ustaw poziomy logów które będą wysyłane do poszczególnych rejestrów.": "Set log levels to be sent to specific registers.",
        "Ustaw poziomy logów które będą zbierane z poszczególnych przestrzeni nazw.": "Set log levels to be collected from specific namespaces.",
        "Ustawienia": "Settings",
        "Ustawienia konta": "Account settings",
        "Ustawienia widgetów zostały zapisane": "Widget settings have been saved",
        "Ustawienia widgetu": "Widget settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "usunął": "removed",
        "Usunął": "Removed",
        "Usunięcie": "Removal",
        "usunięty": "deleted",
        "Usuń": "Delete",
        "Usuń filtr": "Delete filter",
        "Usuń kolor": "Delete color",
        "Usuń plik": "Delete file",
        "Usuń plik z listy": "Delete file from list",
        "Usuń urządzenie": "Delete device",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "Delete device to revoke remembered automatic login to your account",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "Delete${selected.length > 1 ? ' selected' : ''}",
        "Usuwanie użytkowników": "User deletion",
        "Utworzył": "Created",
        "Utwórz katalog": "Create directory",
        "Utwórz nowy": "Create new",
        "Użytkownicy": "Users",
        "Użytkownicy w tej roli": "Users in this role",
        "Użytkownik": "User",
        "Użytkownik \"%0\" %1 obiekt %2": "User \"%0\" %1 object %2",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "User will not receive any notifications.",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "User cannot log in until account is active.",
        "Użytkownik posiada pełne uprawnienia": "User has full privileges",
        "Użytkownik został dodany.": "User has been added.",
        "Użytkownik został usunięty.": "User has been deleted.",
        "Użytkownik został wylogowany.": "User has been logged out.",
        "Użytkownik został zaktualizowany.": "User has been updated.",
        "Użytkownik został zanonimizowany.": "User has been anonymized.",
        "W każdy dzień tygodnia": "Every day of the week",
        "Walidacja certyfikatu SSL": "SSL certificate validation",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "Values from 0 - 1.0 (0 means 0%, and 1 means 100%)",
        "Wartość musi być liczbą całkowitą": "Value must be an integer",
        "Wartość musi być liczbą dodatnią": "Value must be positive",
        "Wartość musi być liczbą ujemną": "Value must be negative",
        "Warunki korzystania z usług Google": "Google Terms of Service",
        "Ważne informacje": "Important information",
        "Wczytywanie danych...": "Loading data...",
        "Weekend": "Weekend",
        "Wersja utowrzona przez": "Version created by",
        "Wersje dokumentu": "Document versions",
        "Wiadomość testowa została wysłana.": "Test message has been sent.",
        "Więcej": "More",
        "więcej...": "more...",
        "Właściwości": "Properties",
        "Włączone": "Enabled",
        "Włączony": "Enabled",
        "Wpisz adresy po przecinku.": "Enter addresses separated by commas.",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "Enter URLs for services you want to exclude. Data can be separated by commas or be in a new line",
        "Wprowadzona wartość jest nieprawidłowa": "Entered value is invalid",
        "Wprowadzona wartość jest za długa": "Entered value is too long",
        "Wprowadzona wartość jest za krótka": "Entered value is too short",
        "Wprowadzona wartość jest za niska": "Entered value is too low",
        "Wprowadzona wartość jest za wysoka": "Entered value is too high",
        "Wprowadzona wartość nie jest poprawna": "Entered value is not correct",
        "Wróć do logowania": "Back to login",
        "Wróć do strony głównej": "Back to homepage",
        "Wstaw cztery kolumny 1/4": "Insert four columns 1/4",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "Insert two columns 1/3 and 2/3",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "Insert two columns 2/3 and 1/3",
        "Wstaw dwie równe kolumny": "Insert two equal columns",
        "Wstaw szablon informacyjny ze zdjęciem": "Insert informational template with photo",
        "Wstaw trzy kolumny 1/3": "Insert three columns 1/3",
        "Wszyscy użytkownicy": "All users",
        "Wszystkie": "All",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!nnCzy na pewno chcesz wykonać akcję??": "All user's personal data in the system will be deleted!nnAre you sure you want to perform the action??",
        "Wybierz": "Select",
        "wybierz długość": "select length",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "Select directory to move selected items.",
        "Wybierz plik": "Select file",
        "Wybierz pliki": "Select files",
        "Wybierz pliki (do {0})": "Select files (up to {0})",
        "Wybierz shortcode": "Select shortcode",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Select users for whom you want to perform actions",
        "Wybierz zaznaczone": "Select selected",
        "wybierz...": "select...",
        "Wybór języka": "Language selection",
        "Wybrane": "Selected",
        "Wybrane elementy zostały przeniesione.": "Selected items have been moved.",
        "Wybrane elementy zostały usunięte.": "Selected items have been deleted.",
        "wybrane elementy?": "selected items?",
        "Wybrane pliki": "Selected files",
        "Wybrane pliki: {0}": "Selected files: {0}",
        "Wybrane: %0": "Selected: %0",
        "wybranego elementu": "selected item",
        "Wybrano %0 użytkowników.": "Selected %0 users.",
        "Wybrano jednego użytkownika.": "Selected one user.",
        "Wybrany element został usunięty.": "Selected item has been deleted.",
        "wybrany element?": "selected item?",
        "wybranych elementów": "selected items",
        "Wyklucz logowanie zależności": "Exclude dependency logging",
        "Wykonaj": "Execute",
        "Wyloguj się": "Log out",
        "Wyloguj zalogowanego obecnie użytkownika": "Log out currently logged-in user",
        "Wyłaczone": "Disabled",
        "Wyłączone wysyłanie powiadomień": "Disabled notification sending",
        "Wymagaj znaków specjalnych w hasłach": "Require special characters in passwords",
        "Wymagane jest ustawienie minimalnej długości hasła": "Setting minimum password length is required",
        "Wymiary": "Dimensions",
        "Wymuś zmianę hasła": "Force password change",
        "Wysłane": "Sent",
        "Wysokość": "Height",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "Error occurred while loading image. Try again.",
        "Wystąpił błąd podczas próby exportu użytkowników.": "Error occurred during user export attempt.",
        "Wystąpił błąd podczas próby importu użytkowników.": "Error occurred during user import attempt.",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Connection error. Ensure internet is enabled and try again.",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Server error occurred during selected operation. Try again.",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Unknown server error occurred during selected operation. Try again.",
        "Wystąpiły błędy podczas zapisywania formularza": "Errors occurred while saving form",
        "Wysyłaj dane o użytkowniku": "Send user data",
        "Wyszukaj (Ctrl+Q)": "Search (Ctrl+Q)",
        "Wyszukaj widget": "Search widget",
        "Wyszukaj...": "Search...",
        "Wyślij": "Send",
        "Wyślij kod": "Send code",
        "Wyświetlam": "Displaying",
        "Wytnij": "Cut",
        "Zaakceptowany": "Accepted",
        "Zabierz dostęp": "Revoke access",
        "Zablokuj": "Block",
        "Zachowaj oryginalny format obrazów": "Preserve original image format",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search user...",
        "Zadanie zostało uruchomione.": "Task has been started.",
        "Zadanie zostało włączone": "Task has been enabled",
        "Zadanie zostało wyłączone": "Task has been disabled",
        "Zaimportowano listę użytkowników.": "User list has been imported.",
        "Zakolejkowane": "Queued",
        "Zakończ sesję": "End session",
        "Zakończ sesję aby wylogować użytkownika": "End session to log out user",
        "Zakończone": "Finished",
        "Zaloguj się": "Log in",
        "Zaloguj się na swoje konto": "Log in to your account",
        "Zamknij": "Close",
        "Zapamiętaj logowanie": "Remember login",
        "Zapamiętane urządzenia": "Remembered devices",
        "Zapisz": "Save",
        "Zapisz aranżację": "Save arrangement",
        "Zapisz filtr": "Save filter",
        "Zapisz i wróć": "Save and back",
        "Zapisz widget": "Save widget",
        "Zapisz zmiany": "Save changes",
        "Zaplanowane": "Scheduled",
        "Zapomniałeś hasła?": "Forgot password?",
        "Zastępstwo": "Substitution",
        "Zaufane adresy IP": "Trusted IP addresses",
        "Zaznacz": "Select",
        "Zaznacz wszystkie": "Select all",
        "Zbieranie i przechowywanie logów": "Log collection and storage",
        "Zdarzenie": "Event",
        "Zdjęcie użytkownika": "User photo",
        "Zespół": "Team",
        "Zmiana hasła": "Password change",
        "Zmiana rozmiaru obrazu": "Image resizing",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!nnCzy na pewno chcesz zapisać zmiany??": "Changing settings may result in loss of access to panel!nnAre you sure you want to save changes??",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "Monitoring settings changes require application restart.",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmień hasło": "Change password",
        "Zmień nazwę": "Rename",
        "Zmień nazwę katalogu": "Rename directory",
        "Zmień nazwę pliku": "Rename file",
        "Zmień rozmiar": "Resize",
        "Zmień status edytowanej wersji": "Change status of edited version",
        "zmodyfikował": "modified",
        "Zmodyfikował": "Modified",
        "zmodyfikowany": "modified",
        "znaki": "characters",
        "Zobacz przed opublikowaniem": "View before publishing",
        "Zobacz sesję użytkownika": "View user session",
        "Zobacz szczegóły sesji użytkownika": "View user session details",
        "Zobacz szczegóły zdarzenia": "View event details",
        "Został przywrócony oryginalny harmonogram": "Original schedule has been restored",
        "Zresetuj hasło": "Reset password",
        "Zrestartuj aplikacje": "Restart application",
        "Zwrócony": "Returned",
        "Źródła logów": "Log sources",
        "Źródło": "Source"
    }
};
